import * as s from './TodaySealedFooter.css';

export interface TodaySealedFooterProps {
  /** 입사 후 누적 (placeholder OK — 백엔드 SEAL counter 도입 전) */
  lifetime: number;
  /**
   * 과거 일지 archive 진입 콜백. 미주입 시 비활성 (단순 표시만).
   * 백엔드 endpoint + archive 패널 도입 시 주입. 본 PR placeholder OK.
   */
  onOpenArchive?: () => void;
  /**
   * H-2 — 마감 CTA 승격. 주입 시 band 우측에 마감 버튼 표시(좌: 카운터, 우: 버튼).
   * 마감 로직은 TodayMemo 소유 — onClose는 '열기 신호'만 보낸다.
   * canClose=false(오늘 업무일지 없음)면 미주입 → 기존처럼 카운터만.
   */
  sealAction?: {
    /** 마감 진행 중 — disabled */
    busy: boolean;
    /** SUBMITTED — 라벨 분기 */
    submitted: boolean;
    /** 마감창 열기 요청 */
    onClose: () => void;
  };
}

/**
 * DesktopWindow `footerSlot`에 주입되는 band.
 * 좌측: 누적 카운터(또는 archive 진입). 우측(H-2): 마감 CTA(sealAction 주입 시).
 * [Source: project_todaypage_daily_sealed_log_motif §누적 카운터]
 */
export function TodaySealedFooter({ lifetime, onOpenArchive, sealAction }: TodaySealedFooterProps) {
  const counter = onOpenArchive ? (
    <button
      type="button"
      id="today-archive-link"
      onClick={onOpenArchive}
      className={s.archiveLink}
      aria-label={`지난 일지 보기 · 마감 ${lifetime}번`}
    >
      <span>지난 일지 보기</span>
      <span className={s.separator}>·</span>
      <span className={s.count}>마감 {lifetime}번</span>
    </button>
  ) : (
    <span className={s.staticLabel} aria-label={`입사 후 ${lifetime}번 마감`}>
      <span>입사 후</span>
      <span className={s.count}>{lifetime}</span>
      <span>번 마감</span>
    </span>
  );

  // 마감 CTA 없으면 기존처럼 카운터만(하위호환 — band는 우측 정렬).
  if (!sealAction) return counter;

  return (
    <div className={s.root}>
      {counter}
      <button
        type="button"
        className={s.sealBtn}
        onClick={sealAction.onClose}
        disabled={sealAction.busy}
      >
        {sealAction.busy
          ? '제출 중...'
          : sealAction.submitted
            ? '수정 후 다시 마감'
            : '오늘 일지 마감'}
      </button>
    </div>
  );
}
